import { get } from 'lodash';
import store from '@/store'
import {tempUnitMap} from '@/utils/const'
import { CHANNEL_GROUP } from '@/utils/const'

// 获取属性值
export const getAttrValue = (data, path, defaultName = '--') => {
    // 65535特殊值，做空值使用
    return get(data, path, defaultName) === '65535' ? defaultName : get(data, path, defaultName)
}

export const mergeDeviceArray = ({newDeviceArray, oldDeviceArray, key = 'deviceId'}) => {
    return oldDeviceArray.map(deviceItem => {
        const waitUpdateItem = newDeviceArray.find(item => item[key] === deviceItem[key]) || {}

        return {
            ...deviceItem,
            realMap: {
                ...(deviceItem.realMap || {}),
                ...(waitUpdateItem.realMap || {})
            }
        }
    })
}

export const getNewValueByDecimals = (deviceTypeKey, deviceId, value, key) => {
    if(typeof Number(value) !== 'number') return;
    const arr = store.state.realTimeData[deviceTypeKey];

    const cur = arr.find(item => item.deviceId === deviceId)

    const decimal = Number(getAttrValue(cur, `realMap.${key}.0.data.decimals`, 1))

    return (value / decimal).toFixed(0)
}

// 补全channel逻辑，有种情况就是channel存在空的情况
export const getTotalChannel = (channels) => {
    // 判断是否是更新逻辑
    const refresh = channels.find(g => g.refresh)
    if(!refresh) return channels;

    return Object.values(CHANNEL_GROUP).map(moduleId => {
        const currentChannel = channels.find(channel => channel.moduleId === moduleId);

        if(!currentChannel) {
            return {
                moduleId,
                refresh: true,
                groupList: [],
                simpleList: []
            }
        }

        return currentChannel
    })

}


export const setChancel = ({deviceId, vehicleId, value}) => {
    uni.$socket.send(82, {
       "vehicleId": vehicleId,
       "setList": [
         {
             "deviceTypeKey": "channel",
             deviceId,
             "setMap": {
                 "switch_state": value
             }
         }
       ]
    })
}

export const setSystemInfo = ({deviceId, vehicleId, key, value}) => {
   const newValue = getNewValueByDecimals('system', deviceId, value, key)
   uni.$socket.send(86, {
      "vehicleId": vehicleId,
      "setList": [
        {
            "deviceTypeKey": "system",
            deviceId,
            "setMap": {
                [key]: newValue
            }
        }
      ]
   })
}

export const getGlobalTempUnit = () => {
    const unit = getAttrValue(store.state.realTimeData.system, '0.realMap.temp_unit.0.data.value', 0)
    return tempUnitMap[unit]
}

export const cToF = (temp) => {
    if(temp === '--') {
        return temp
    }
    const unit = Number(getAttrValue(store.state.realTimeData.system, '0.realMap.temp_unit.0.data.value', 0))
    if(unit === 1) {
        temp = temp * 9 / 5 + 32
    }

    return temp;
}

// 获取天，时， 分
export const getDHMTime = (mins) => {
    const D = Math.floor(mins / (24 * 60))

    let restMin = mins % (24 * 60)

    const H = Math.floor(restMin / 60)

    restMin = restMin % 60


    return D ? `${D}d${H}h${restMin}min` : (H ?  `${H}h${restMin}min`: `${restMin}min`)

}

export const ensureDecimals = (value, precision = 1, removeSuffixZero)  =>{
    // 1. 处理无效输入
    if (typeof value !== 'number' || isNaN(value)) { 
      throw new TypeError('输入必须是有效数字');
    }
    if(Number.isInteger(value)) {
        return value.toString().replace(/\.0+/, '')
    }
    // 2. 处理科学计数法和大数
    const strValue = value.toString();
    if (strValue.includes('e')) {
      value = Number.parseFloat(strValue); // 转换为常规数字
    }
  
    // 3. 精准四舍五入（避免浮点误差）
    const factor = 10 ** 5;
    const rounded = Math.round(value * factor + Number.EPSILON) / factor;
  
    // 4. 格式化为五位小数（自动补零）
    const formatted = rounded.toLocaleString('en-US', {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
      useGrouping: false
    });
  
    return formatted;
}
